import {useMemo} from "react";
import {useUserPreferences} from "./userPreferencesHooks";
import {useLocalizedEnumItems} from "./localizedEnumItemsHooks";
import {MEASURE_UNITS} from "../utils/enumItemsUtils";
import {getMeasureSystemUtilsClosure} from "../utils/measureSystemUtils";

export const useMeasureSystemUtils = () => {
    const {measureSystem} = useUserPreferences();
    const {itemsById: measureUnits} = useLocalizedEnumItems(MEASURE_UNITS);

    return useMemo(() => getMeasureSystemUtilsClosure(measureUnits, measureSystem), [measureUnits, measureSystem]);
};
